import * as u from "react";
import e from "./chunk901.js";
import g from "clsx";
import b from "./chunk932.js";
import { getSnackbarContentUtilityClass as C } from "./chunk1071.js";
import { jsxs as k, jsx as l } from "react/jsx-runtime";
import n from "./chunk834.js";
import S from "./chunk953.js";
import { useDefaultProps as v } from "./chunk954.js";
import x from "./chunk957.js";
import { emphasize as y } from "./chunk848.js";
const R = (o) => {
  const {
    classes: t
  } = o;
  return x({
    root: ["root"],
    action: ["action"],
    message: ["message"]
  }, C, t);
}, w = n(S, {
  name: "MuiSnackbarContent",
  slot: "Root",
  overridesResolver: (o, t) => t.root
})(b(({
  theme: o
}) => {
  const t = o.palette.mode === "light" ? 0.8 : 0.98, r = y(o.palette.background.default, t);
  return {
    ...o.typography.body2,
    color: o.vars ? o.vars.palette.SnackbarContent.color : o.palette.getContrastText(r),
    backgroundColor: o.vars ? o.vars.palette.SnackbarContent.bg : r,
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    padding: "6px 16px",
    borderRadius: (o.vars || o).shape.borderRadius,
    flexGrow: 1,
    [o.breakpoints.up("sm")]: {
      flexGrow: "initial",
      minWidth: 288
    }
  };
})), N = n("div", {
  name: "MuiSnackbarContent",
  slot: "Message",
  overridesResolver: (o, t) => t.message
})({
  padding: "8px 0"
}), M = n("div", {
  name: "MuiSnackbarContent",
  slot: "Action",
  overridesResolver: (o, t) => t.action
})({
  display: "flex",
  alignItems: "center",
  marginLeft: "auto",
  paddingLeft: 16,
  marginRight: -8
}), T = /* @__PURE__ */ u.forwardRef(function(t, r) {
  const c = v({
    props: t,
    name: "MuiSnackbarContent"
  }), {
    action: i,
    className: p,
    message: m,
    role: d = "alert",
    ...f
  } = c, s = c, a = R(s);
  return /* @__PURE__ */ k(w, {
    role: d,
    square: !0,
    elevation: 6,
    className: g(a.root, p),
    ownerState: s,
    ref: r,
    ...f,
    children: [/* @__PURE__ */ l(N, {
      className: a.message,
      ownerState: s,
      children: m
    }), i ? /* @__PURE__ */ l(M, {
      className: a.action,
      ownerState: s,
      children: i
    }) : null]
  });
});
process.env.NODE_ENV !== "production" && (T.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The action to display. It renders after the message, at the end of the snackbar.
   */
  action: e.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: e.object,
  /**
   * @ignore
   */
  className: e.string,
  /**
   * The message to display.
   */
  message: e.node,
  /**
   * The ARIA role attribute of the element.
   * @default 'alert'
   */
  role: e.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: e.oneOfType([e.arrayOf(e.oneOfType([e.func, e.object, e.bool])), e.func, e.object])
});
export {
  T as default
};
